import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { DelegateItem, DelegateListItem } from "src/api/delegate/delegateApi";

type DelegateQuery = {
  delegateName: string;
  page: number; // UI 1-based
  size: number;
  order: string; // "createdAt,desc"
};

type DelegateState = DelegateQuery & {
  // modal
  dialogOpen: boolean;
  editItem: DelegateListItem | null;

  setQuery: (q: Partial<DelegateQuery>) => void;
  resetQuery: () => void;

  openCreate: () => void;
  openEdit: (item: DelegateListItem) => void;
  closeDialog: () => void;
};

const isDev = process.env.NODE_ENV === "development";

export const useDelegateStore = create<DelegateState>()(
  devtools(
    (set) => ({
      delegateName: "",
      page: 1,
      size: 20,
      order: "createdAt,desc",

      dialogOpen: false,
      editItem: null,

      setQuery: (q) => set((s) => ({ ...s, ...q }), false, "delegate/setQuery"),
      resetQuery: () =>
        set(
          { delegateName: "", page: 1, size: 20, order: "createdAt,desc" },
          false,
          "delegate/resetQuery"
        ),

      openCreate: () => set({ dialogOpen: true, editItem: null }, false, "delegate/openCreate"),
      openEdit: (item) => set({ dialogOpen: true, editItem: item }, false, "delegate/openEdit"),
      closeDialog: () => set({ dialogOpen: false, editItem: null }, false, "delegate/closeDialog"),
    }),
    { name: "delegate-store", enabled: isDev }
  )
);
